import MuiFormHelperText from '@mui/material/FormHelperText';
import { styled } from '@mui/material/styles';

export const StyledFormHelperText = styled(MuiFormHelperText)({}) as typeof MuiFormHelperText;
